<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Go Live'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'getting-started' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (isLoading) {
      <tidy-loader [show]="true" />
    }

    @if (!isLoading) {

      <tidy-row [align]="'center'" class="extra-top-padding">
        <tidy-text [title]="'Go Live with TIDY AI Property Management'" />
      </tidy-row>

      <tidy-row [align]="'center'" class="extra-bottom-padding">
        <tidy-text [body]="'Everything a PM does. For 3.9%.'" />
      </tidy-row>

      <div class="gl-card">
        <div class="gl-card-icon-wrap">
          <tidy-image [src]="'assets/svg/flash-outline.svg'" class="gl-card-icon" />
        </div>
        <div class="gl-card-body">
          <div class="gl-card-title-row">
            <tidy-text [header]="'Cleaning & Maintenance'" />
            <span class="gl-badge">THE HARD PART</span>
          </div>
          <tidy-text
            class="gl-card-desc"
            [body]="'The deepest technology stack built for cleaning and maintenance \u2014 12 years in the making.'" />
        </div>
      </div>

      <div class="gl-card">
        <div class="gl-card-icon-wrap">
          <tidy-image [src]="'assets/svg/cash-outline.svg'" class="gl-card-icon" />
        </div>
        <div class="gl-card-body">
          <div class="gl-card-title-row">
            <tidy-text [header]="'Revenue Optimization'" />
          </div>
          <tidy-text
            class="gl-card-desc"
            [body]="'More reservations. Higher revenue per guest. Lower operating costs.'" />
        </div>
      </div>

      <div class="gl-card">
        <div class="gl-card-icon-wrap">
          <tidy-image [src]="'assets/svg/checkmark-circle.svg'" class="gl-card-icon" />
        </div>
        <div class="gl-card-body">
          <div class="gl-card-title-row">
            <tidy-text [header]="'Guest Experience'" />
          </div>
          <tidy-text
            class="gl-card-desc"
            [body]="'Automate the guest touchpoints that drive 5-star reviews.'" />
        </div>
      </div>

      <div class="gl-card">
        <div class="gl-card-icon-wrap">
          <tidy-image [src]="'assets/svg/shield-checkmark-outline.svg'" class="gl-card-icon" />
        </div>
        <div class="gl-card-body">
          <div class="gl-card-title-row">
            <tidy-text [header]="'Risk Reduction'" />
          </div>
          <tidy-text
            class="gl-card-desc"
            [body]="'Stay protected and stay legal \u2014 nothing slips through the cracks.'" />
        </div>
      </div>

      <tidy-button
        [text]="isLive ? 'Live' : 'Go Live'"
        [action]="handleGoLive"
        [disabled]="isLive"
        class="hero full-width gl-hero-btn extra-top-padding extra-bottom-padding"
        [ngClass]="{'go-live-active': isLive}" />
    }

  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
